/**
 * LanguageListContainer component.
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Props for LanguageListContainer component.
 */
interface Props {
  animate?: boolean;
}

/**
 * Styled language list container.
 */
const LanguageListContainer = styled.div<Props>`
  position: absolute;
  left: ${1060 * Screen.widthRatio}px;
  top: ${({ animate }) => (animate ? 524 : 460) * Screen.widthRatio}px;
  width: ${150 * Screen.widthRatio}px;
`;

export default LanguageListContainer;
